interface AdminPageHeaderProps {
  title: string;
  children?: React.ReactNode;
}

const AdminPageHeader = ({ title, children }: AdminPageHeaderProps) => {
  return (
    <div className="flex justify-between items-center min-h-10">
      <h2 className="text-2xl font-bold">{title}</h2>
      {children}
    </div>
  );
};

export default AdminPageHeader;
